<div class="card" [class]="'card--variant-' + variant()">
  @switch (headingLevel()) {
    @case ('h2') {
      <h2 class="card__title">{{ title() | translate }}</h2>
    }
    @default {
      <h3 class="card__title">{{ title() | translate }}</h3>
    }
  }
  <div class="card__content">
    @if(content()) {
    <p>{{ content() | translate }}</p>
    } @else {
    <ng-content></ng-content>
    }
  </div>
</div>
